import Vue from 'vue';
import singleSpaVue from 'single-spa-vue';
import VueCompositionAPI from '@vue/composition-api';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);
const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h: any) {
      return h(App, {
        props: {
          // single-spa props are available on the "this" object. Forward them to your component as needed.
          // https://single-spa.js.org/docs/building-applications#lifecyle-props
          // if you uncomment these, remember to add matching prop definitions for them in your App.vue file.

          name: (this as any).name,
          mountParcel: (this as any).mountParcel,
          singleSpa: (this as any).singleSpa,
        },
      });
    },
    router,
  },
});
export const { bootstrap, mount, unmount, update } = vueLifecycles;
